import type { UserLevel } from '@/types'

export interface MenuItemDef {
  key: string
  label: string
  path: string
  icon?: string
  requiredModule?: string
  requiredFunction?: string
  maxUserLevel: UserLevel
  children?: MenuItemDef[]
}

// 기록입력 시스템에 필요한 메뉴만 남긴다.
// estimate(고과평가/연봉) 프로젝트에서 넘어온 배점설정·평가결과·연봉산정·연봉협상·Stat&연봉·배치·데이터관리는
// 이 프로젝트의 요구사항이 아니라 화면과 함께 제거했다(루트 CLAUDE.md "현재 구현 범위" 참고).
export const MENU_DEFINITIONS: MenuItemDef[] = [
  {
    key: 'games',
    label: '경기목록',
    path: '/games',
    icon: 'calendar',
    maxUserLevel: 9,
  },
]

export function filterMenu(
  menus: MenuItemDef[],
  userLevel: UserLevel,
  activeModules: string[],
  activeFunctions: string[],
): MenuItemDef[] {
  return menus
    .filter((menu) => {
      const levelOk = userLevel <= menu.maxUserLevel
      const moduleOk = !menu.requiredModule || activeModules.includes(menu.requiredModule)
      const funcOk = !menu.requiredFunction || activeFunctions.includes(menu.requiredFunction)
      return levelOk && moduleOk && funcOk
    })
    .map((menu) => ({
      ...menu,
      children: menu.children
        ? filterMenu(menu.children, userLevel, activeModules, activeFunctions)
        : undefined,
    }))
}
